import { disableBodyScroll, enableBodyScroll } from "../utils";

export default class QuoteForm {
  constructor() {
    this.$buttons = document.querySelectorAll(".js-get-started-btn");
    this.$addressInputs = document.querySelectorAll(".js-address-input");
    this.$addressInputConatiners = document.querySelectorAll(
      ".js-address-input-container input"
    ); // this is from gravity forms as you cant put a class on the input directly
    this.$freeQuoteForms = document.querySelectorAll(".js-free-quote-form");
    this.$leadCaptureForm = document.querySelector(".js-lead-capture-form");
    this.$leadCaptureFormBackground = document.querySelector(
      ".js-lead-capture-form-bg"
    );
    this.$leadCaptureFormClose = document.querySelector(
      ".js-lead-capture-form-close"
    );

    this.$buttons.forEach(($button) => this.setupButton($button));
    this.$freeQuoteForms.forEach(($form) => this.setupForm($form));
    this.$addressInputs.forEach(($input) => this.setupAddressInput($input));
    this.$addressInputConatiners.forEach(($input) =>
      this.setupAddressInput($input)
    );

    this.$leadCaptureFormClose.addEventListener("click", this.close.bind(this));

    this.componentForm = {
      street_number: {
        key: "short_name",
        inputId: "input_1_3",
      },
      route: {
        key: "long_name",
        inputId: "input_1_5",
      },
      locality: {
        key: "long_name",
        inputId: "input_1_6",
      },
      administrative_area_level_1: {
        key: "short_name",
        inputId: "input_1_7",
      },
      country: {
        key: "long_name",
        inputId: "input_1_8",
      },
      postal_code: {
        key: "short_name",
        inputId: "input_1_8",
      },
    };
  }

  setupButton($button) {
    $button.addEventListener("click", (e) => {
      e.preventDefault();
      this.open();
    });
  }

  setupForm($form) {
    $form.addEventListener("submit", (e) => {
      e.preventDefault();
      this.setFormAddressValue($form);
      this.open();
    });
  }

  setFormAddressValue($form) {
    const value = $form.querySelector(".js-address-input").value;

    this.$addressInputConatiners.forEach(($input) => {
      $input.value = value;
    });
  }

  setupAddressInput($input) {
    const autocomplete = new google.maps.places.Autocomplete($input, {
      componentRestrictions: { country: "us" },
      fields: ["address_components", "geometry", "icon", "name"],
    });

    // When the user selects an address from the dropdown, populate the address fields in the form.
    autocomplete.addListener("place_changed", () => {
      this.fillInAddress(autocomplete);
    });
  }

  open() {
    disableBodyScroll();
    this.$leadCaptureForm.setAttribute("aria-hidden", "false");
    this.$leadCaptureForm.classList.add("is-visible");
    this.$leadCaptureFormBackground.classList.add("is-visible");
  }

  close() {
    enableBodyScroll();
    this.$leadCaptureForm.setAttribute("aria-hidden", "true");
    this.$leadCaptureForm.classList.remove("is-visible");
    this.$leadCaptureFormBackground.classList.remove("is-visible");
  }

  fillInAddress(autocomplete) {
    const place = autocomplete.getPlace();

    // Get each component of the address from the place details
    // and fill the corresponding field on the form.
    for (let i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (this.componentForm[addressType]) {
        const val =
          place.address_components[i][this.componentForm[addressType].key];
        document.getElementById(
          this.componentForm[addressType].inputId
        ).value = val;
      }
    }
  }
}
